import { baseSchemaProperties } from '../base-schema-properties'

export default {
  $schema: 'http://json-schema.org/draft-07/schema#',
  title: 'Program',
  description: 'Event program',
  type: 'object',
  required: ['title', 'eventId', 'programId'],
  properties: {
    ...baseSchemaProperties,
    title: {
      title: 'Program',
      type: 'string',
    },
    eventId: {
      title: 'Event id',
      type: 'number',
    },
    programId: {
      title: 'Program id',
      type: 'number',
    },
  },
}
